<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 512 512"
>
  <path
    fill="#ffffff"
    d="M256 405.333 114.325 287.296l27.328-32.79 93.014 77.505V64h42.666v268.01l92.992-77.503 27.328 32.789L256 405.333Zm-170.667 0h341.334V448H85.333v-42.667Z"
  />
</svg>
